import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";
import btcSrc from "../assests/crypto.png";
import { motion } from "framer-motion";

const Home = () => {
  return (
    <Box w={"full"} h={"100vh"} bgColor={"blackAlpha.900"}>
      <motion.div
        style={{
          height: "80vh",
        }}
        animate={{
          translateY: "20px",
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      >
        <Image
          w={"full"}
          h={"full"}
          objectFit={"contain"}
          src={btcSrc}
          filter={"grayscale(1)"}
          p={["5","0"]}
        />
      </motion.div>

      <Text
        fontSize={["4xl","6xl"]}
        textAlign={"center"}
        fontWeight={"thin"}
        color={"whiteAlpha.700"}
        mt={"10"}
      >
        CryptoXkelvin
      </Text>
    </Box>
  );
};

export default Home;
